<dv-dialog-content>
  <dv-dynamic-form
    [elements]="elements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <div class="geofence-info">
    <div class="geofence-info__icon">
      <span class="dv-icons">info_filled</span>
    </div>
    <div class="geofence-info__text">
      {{ 'CreateGeofenceDialog.Info' | translate }}
    </div>
  </div>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
